import { connect } from 'react-redux'
import {fetchUser, handleSignOut, getNotifications, clearNotification} from '../../store/user/duck'
import { getClientStrategist, 
         getClientAgent, 
         scheduleMeeting,
         getSearchedClients } from '../../store/client/duck'
import {getAllClients, clearAllagentLogedData } from '../../store/agent/duck'
import {getAllUsers, saveAuthtoken} from '../../store/dashboard/duck'
import { getChatHistory } from '../../store/chat/duck'
import TopNavigationForm from './component'

const TopNavigation = connect(
  // Map state to props
  (state) => ({
    user: state.user.users,
    isSubmitting: state.user.isSubmitting,
    rxError: state.user.error,
    profilePhase: state.user.profilePhase,
    authTokenPhase:state.dashboard.authTokenPhase,
    agentData: state.client.agentData,
    resMessage: state.client.resMessage,
    allclientData: state.agent.allclientData,
    saveAuthtokenData: state.dashboard.saveAuthtokenData,
    allUserData: state.dashboard.allUserData,
    notificationPhase: state.user.notificationPhase,
    notificationData: state.user.notificationData,
    clearNotificationPhase: state.user.clearNotificationPhase,
    chatHistoryData: state.chat.chatHistoryData
  }),
  // Map actions to props
  {
    fetchUser,
    handleSignOut,
    getClientStrategist,
    getClientAgent,
    scheduleMeeting,
    getSearchedClients,
    getAllClients,
    getAllUsers,
    saveAuthtoken,
    getNotifications,
    clearNotification,
    clearAllagentLogedData,
    getChatHistory,
  }
)(TopNavigationForm)
export default TopNavigation
